import { Action } from '@ngrx/store';
import { DashboardItem } from '../../dashboards/models/dashboard-item';

export const LOAD = '[Dashboard Designer] Load';
export const LOAD_COMPLETE = '[Dashboard Designer] Load Complete';
export const LOAD_ERROR = '[Dashboard Designer] Load Error';
export const SET_CURRENT_DASHBOARD = '[Dashboard Designer] Set Current Dashboard';
export const SET_CURRENT_PROFILE = '[Dashboard Designer] Set Current Profile';
export const ADD_WIDGET = '[Dashboard Designer] Add Dashboard Designer Widget';
export const DELETE_WIDGET = '[Dashboard Designer] Delete Widget';
export const MOVE_WIDGET = '[Dashboard Designer] Move Widget';
export const RESET = '[Dashboard Designer] Reset';
export const ENTER_DESIGNER = '[Dashboard Designer] Enter Designer';
export const EXIT_DESIGNER = '[Dashboard Designer] Exit Designer';

export class Load implements Action {
  readonly type = LOAD;
  constructor(public payload: LoadArguments) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: DashboardItem[]) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any) { }
}

export class SetCurrentDashboard implements Action {
  readonly type = SET_CURRENT_DASHBOARD;

  constructor(public readonly payload: string ) {  }
}

export class SetCurrentProfile implements Action {
  readonly type = SET_CURRENT_PROFILE;
  constructor(public readonly payload: number) { }
}

export class AddWidget implements Action {
  readonly type = ADD_WIDGET;
  constructor(public payload: SingleWidgetArguments) { }
}

export class DeleteWidget implements Action {
  readonly type = DELETE_WIDGET;
  constructor(public payload: SingleWidgetArguments) { }
}

export class MoveWidget implements Action {
  readonly type = MOVE_WIDGET;
  constructor(public payload: SingleWidgetArguments) { }
}

export class Reset implements Action {
  readonly type = RESET;
  constructor(public payload: ResetArguments ) { }
}

export class EnterDesignerMode implements Action {
  readonly type = ENTER_DESIGNER;
  constructor(public payload?: any) { }
}

export class ExitDesignerMode implements Action {
  readonly type = EXIT_DESIGNER;
  constructor(public payload?: any) { }
}

export type Actions =
  Load |
  LoadComplete |
  LoadError |
  SetCurrentDashboard |
  SetCurrentProfile |
  AddWidget |
  DeleteWidget |
  MoveWidget |
  Reset |
  EnterDesignerMode |
  ExitDesignerMode;

export class LoadArguments {
  constructor(public readonly profileId: number, public readonly dashboardIdentifier: string) {}
}

export class ResetArguments {
  constructor(public readonly profileId: number, public readonly dashboardIdentifier: string) { }
}


export class SingleWidgetArguments {
  constructor(public readonly profileId: number, public readonly dashboardIdentifier: string, public readonly dashboardItem: DashboardItem) { }
}

